import React from 'react';
import Text from 'components/Text';
import EventTracking from 'lib/EventTracking';

export default class NoStudentsView extends React.Component {
  componentDidMount() {
    EventTracking.trackKey('coaching.select_student.no_students.view');
  }

  render() {
    return (
      <Text size="medium" color="thunder">
        No students found. Email us at coaching@remind.com to enroll your students.
      </Text>
    );
  }
}
